function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function inlineFormat(text) {
  let out = escapeHtml(text);
  out = out.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  out = out.replace(/__(.+?)__/g, '<strong>$1</strong>');
  out = out.replace(/\*([^*\n]+)\*/g, '<em>$1</em>');
  out = out.replace(/`([^`]+)`/g, '<code class="askq-code">$1</code>');
  return out;
}

/**
 * Converts lightweight markdown in chat replies to safe HTML for display.
 */
export function formatChatMessage(text) {
  if (!text) {
    return '';
  }

  const lines = String(text).split(/\r?\n/);
  const html = [];
  let inUl = false;
  let inOl = false;

  function closeLists() {
    if (inUl) {
      html.push('</ul>');
      inUl = false;
    }
    if (inOl) {
      html.push('</ol>');
      inOl = false;
    }
  }

  lines.forEach((rawLine) => {
    const line = rawLine.trim();

    if (!line) {
      closeLists();
      return;
    }

    const h3 = line.match(/^###\s+(.+)$/);
    const h2 = line.match(/^##\s+(.+)$/);
    const h1 = line.match(/^#\s+(.+)$/);
    if (h1 || h2 || h3) {
      closeLists();
      const match = h1 || h2 || h3;
      const tag = h1 ? 'h4' : h2 ? 'h5' : 'h6';
      html.push('<' + tag + ' class="askq-h">' + inlineFormat(match[1]) + '</' + tag + '>');
      return;
    }

    const sectionHeading = line.match(/^\*\*(.+?)\*\*:?\s*$/);
    if (sectionHeading) {
      closeLists();
      html.push('<p class="askq-heading"><strong>' + inlineFormat(sectionHeading[1]) + '</strong></p>');
      return;
    }

    const sectionWithBody = line.match(/^\*\*(.+?)\*\*:\s*(.+)$/);
    if (sectionWithBody) {
      closeLists();
      html.push(
        '<p class="askq-heading-line"><strong>' +
          inlineFormat(sectionWithBody[1]) +
          ':</strong> ' +
          inlineFormat(sectionWithBody[2]) +
          '</p>'
      );
      return;
    }

    const plainHeading = line.match(/^([A-Za-z][A-Za-z0-9 \-/&]{1,48}):\s*$/);
    if (plainHeading) {
      closeLists();
      html.push('<p class="askq-heading"><strong>' + inlineFormat(plainHeading[1]) + ':</strong></p>');
      return;
    }

    const bullet = line.match(/^[-*•]\s+(.+)$/);
    if (bullet) {
      if (inOl) {
        html.push('</ol>');
        inOl = false;
      }
      if (!inUl) {
        html.push('<ul class="askq-list">');
        inUl = true;
      }
      html.push('<li>' + inlineFormat(bullet[1]) + '</li>');
      return;
    }

    const numbered = line.match(/^\d+[.)]\s+(.+)$/);
    if (numbered) {
      if (inUl) {
        html.push('</ul>');
        inUl = false;
      }
      if (!inOl) {
        html.push('<ol class="askq-list">');
        inOl = true;
      }
      html.push('<li>' + inlineFormat(numbered[1]) + '</li>');
      return;
    }

    closeLists();
    html.push('<p>' + inlineFormat(line) + '</p>');
  });

  closeLists();
  return html.join('');
}
